import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  namespaced: true,
  state: {
    step: "signin",
    error: []
  },
  mutations,
  actions,
  getters
};
